module.exports = __webpack_public_path__ + "static/media/11C.5eabafb8.png";